import React, { SyntheticEvent } from "react";

import { Card, Icon } from "components";

// InformationCard Figma reference:
// https://www.figma.com/file/Jc9kcxKurjLuMvmNgxtE6e/Design-Library?node-id=14509%3A124760&mode=dev

type InformationCardProps = {
  className?: string;
  dataTestId?: string;
  iconName: string;
  text: string;
  title: string;
  variant: "alert" | "confirmation" | "neutral" | "warning";
  onClick?: (event: SyntheticEvent) => void;
  showIcon?: boolean;
};

export const InformationCard = ({ dataTestId, className, iconName = "", text, title, variant, onClick = () => {}, showIcon = true }: InformationCardProps) => {
  const getDefaultIcon = (): string => {
    switch (variant) {
      case "alert":
        return "tabler/wallet-disabled";
      default:
        return "tabler/wallet";
    }
  };

  return (
    <Card
      data-testid={`${dataTestId}-information-card`}
      className={`information-card ${variant} ${className}`}
      onClick={onClick}
      mixpanelText="information-card"
    >
      <div>
        {showIcon && <Icon iconName={iconName || getDefaultIcon()} size="m" />}
        <h4>{title}</h4>
        <p>{text}</p>
      </div>
    </Card>
  );
};
